const $ = jQuery;

export const customDots = ( event, slick ) => {
	if ( ! slick.$dots ) {
		return;
	}

	if ( slick.options.slidesToScroll > 1 || slick.options.swipeToSlide ) {
		return;
	}

	slick.$dots.children().wrapAll( '<div class="slick-dots__inner"></div>' );

	const $dot = $( 'li', slick.$dots ),
		$slickDotsInner = $( '.slick-dots__inner' );

	$slickDotsInner.addClass( 'slick-dots__inner--is-mod' );

	$dot.not( '.slick-active' ).css( 'transform', 'scale(0.5)' );

	$( $dot[ 1 ] ).css( 'transform', 'scale(1)' );
	$( $dot[ 2 ] ).css( 'transform', 'scale(0.8)' );
	$( $dot[ 3 ] ).css( 'transform', 'scale(0.6)' );
	$( $dot[ 4 ] ).css( 'transform', 'scale(0.5)' );

	let offset = 39,
		dotsTranslate = offset * -1,
		prevSlide = 0;

	const afterChangeHandler = ( event, slick, currentSlide ) => {
		if ( currentSlide == prevSlide ) {
			return;
		}

		const decl = prevSlide - currentSlide;
		const isDirectionToPrev =
			decl == 1 || decl == ( slick.slideCount - 1 ) * -1;
		const isDirectionToNext = ! isDirectionToPrev;

		prevSlide = currentSlide;

		// if this slide locate between third from the start and pre-last.
		if ( currentSlide >= 2 && currentSlide < slick.slideCount - 2 ) {
			$( $dot[ currentSlide - 2 ] ).css( 'transform', 'scale(0.5)' );
			$( $dot[ currentSlide + 2 ] ).css( 'transform', 'scale(0.5)' );
		}

		if ( currentSlide == 2 ) {
			if ( isDirectionToPrev ) {
				if ( $dot.length > 5 ) {
					dotsTranslate = dotsTranslate + offset;

					$slickDotsInner.css(
						'transform',
						`translateX(${ dotsTranslate }px)`
					);
				}
			}
		}

		if ( currentSlide == 3 ) {
			if ( isDirectionToPrev ) {
				$( $dot[ currentSlide + 2 ] ).css( 'transform', 'scale(0.6)' );

				if ( $dot.length > 5 ) {
					dotsTranslate = dotsTranslate + offset;
				}
			}

			if ( $dot.length > 5 ) {
				// if slick.$dots is not translated
				if ( dotsTranslate == offset * -1 ) {
					offset = offset - currentSlide;
				}

				if ( dotsTranslate > offset * -1 ) {
					dotsTranslate = dotsTranslate - offset;
				}

				if ( currentSlide + 1 != slick.slideCount - 1 ) {
					$slickDotsInner.css(
						'transform',
						`translateX(${ dotsTranslate }px)`
					);
				}
			}
		}

		if ( isDirectionToNext ) {
			// if this is pre-last slide
			if ( currentSlide == slick.slideCount - 2 ) {
				$( $dot[ currentSlide - 2 ] ).css( 'transform', 'scale(0.6)' );
			}

			// if this is last slide
			if ( currentSlide == slick.slideCount - 1 ) {
				$( $dot[ currentSlide - 2 ] ).css( 'transform', 'scale(0.8)' );
			}
		}

		if ( isDirectionToPrev ) {
			if ( currentSlide == 0 ) {
				$( $dot[ currentSlide + 2 ] ).css( 'transform', 'scale(0.8)' );

				$( $dot[ currentSlide - 2 ] ).css( 'transform', 'scale(1)' );

				$( $dot[ currentSlide + 3 ] ).css( 'transform', 'scale(0.6)' );
			}

			if ( currentSlide == 1 ) {
				$( $dot[ currentSlide + 2 ] ).css( 'transform', 'scale(0.8)' );
			}
		}

		// if this slide locate between 4th and pre-last slides
		if ( currentSlide > 3 && currentSlide < slick.slideCount - 2 ) {
			if ( $dot.length > 5 ) {
				if ( isDirectionToNext ) {
					dotsTranslate = dotsTranslate - offset;
				}

				if (
					isDirectionToPrev &&
					currentSlide < slick.slideCount - 3
				) {
					dotsTranslate = dotsTranslate + offset;
				}

				$slickDotsInner.css(
					'transform',
					`translateX(${ dotsTranslate }px)`
				);
			}
		}

		$( $dot[ currentSlide ] ).css( 'transform', 'scale(1.2)' );
		$( $dot[ currentSlide + 1 ] ).css( 'transform', 'scale(1)' );
		$( $dot[ currentSlide - 1 ] ).css( 'transform', 'scale(1)' );
	};

	slick.$slider.on( 'afterChange', afterChangeHandler );
};
